var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 286,
    viewBox: "0 0 350 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.826 72.9191L130.682 83.9574L85.502 57.7431L105.334 46.708L149.826 72.9191Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.826 131.209L130.682 142.245L85.502 116.033L105.334 104.995L149.826 131.209Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.716 131.209L130.572 142.245L85.3926 116.033L105.224 104.995L149.716 131.209Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.682 83.958V142.245",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.505 46.708V104.995L85.5195 116.014V57.7239",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.824 72.7273V131.017",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.122 105.686L70.9777 116.724L25.7949 90.5099L45.6267 79.4749L90.122 105.686Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.122 163.973L70.9777 175.012L25.7949 148.8L45.6267 137.762L90.122 163.973Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0095 163.973L70.8683 175.012L25.6855 148.8L45.5174 137.762L90.0095 163.973Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9766 116.725V175.012",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7978 79.4751V137.762L25.8125 148.781V90.491",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1211 105.494V163.784",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.873 102.062L252.732 113.1L207.549 86.8894L227.381 75.8511L271.873 102.062Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.873 160.352L252.732 171.39L207.549 145.176L227.381 134.141L271.873 160.352Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.763 160.352L252.622 171.39L207.439 145.176L227.271 134.141L271.763 160.352Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73 113.101V171.391",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.552 75.8511V134.141L207.566 145.157V86.8702",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.871 101.874V160.161",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.187 134.952L312.043 145.99L266.863 119.776L286.695 108.74L331.187 134.952Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.187 193.241L312.043 204.277L266.863 178.065L286.695 167.027L331.187 193.241Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.077 193.241L311.933 204.277L266.75 178.065L286.582 167.027L331.077 193.241Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.041 145.99V204.276",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.863 108.74V167.027L266.881 178.046V119.756",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.186 134.759V193.049",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.383 62.642L184.524 73.6803L229.707 47.466L209.875 36.4309L165.383 62.642Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.383 120.932L184.524 131.967L229.707 105.756L209.875 94.718L165.383 120.932Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.492 120.932L184.633 131.967L229.816 105.756L209.984 94.718L165.492 120.932Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.523 73.6807V131.967",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.701 36.4307V94.7174L229.686 105.737V47.4466",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.383 62.45V120.74",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.264 36.3794L142.405 47.4145L187.588 21.2033L167.756 10.165L123.264 36.3794Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.264 94.666L142.405 105.704L187.588 79.4931L167.756 68.4548L123.264 94.666Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.373 94.666L142.514 105.704L187.697 79.4931L167.865 68.4548L123.373 94.666Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.404 47.415V105.705",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.584 10.165V68.455L187.569 79.4741V21.1841",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.264 36.188V94.4779",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.258 215.416L187.402 226.451L232.585 200.24L212.753 189.205L168.258 215.416Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.258 273.703L187.402 284.742L232.585 258.53L212.753 247.492L168.258 273.703Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.371 273.703L187.512 284.742L232.695 258.53L212.863 247.492L168.371 273.703Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4 226.451V284.741",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58 189.205V247.492L232.565 258.511V200.221",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.258 215.224V273.514",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.678 189.276L149.822 200.311L195.005 174.1L175.173 163.061L130.678 189.276Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.678 247.563L149.822 258.601L195.005 232.387L175.173 221.352L130.678 247.563Z",
    stroke: "#231F20",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.791 247.563L149.932 258.601L195.115 232.387L175.283 221.352L130.791 247.563Z",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82 200.311V258.601",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 163.061V221.351L194.985 232.367V174.08",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.678 189.084V247.371",
    stroke: "white",
    strokeWidth: 0.853772,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5352 70.4219L342.37 234.653",
    stroke: "white",
    strokeWidth: 5.12583,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.161 215.272L244.329 250.347L100.738 167.042L163.764 131.967L305.161 215.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4746 202.469L105.5 167.394",
    stroke: "white",
    strokeWidth: 5.12583,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.16 155.121C145.265 154.869 144.596 154.677 143.861 154.469C145.239 152.221 146.579 150.044 147.97 147.773C147.26 147.594 146.671 147.447 145.984 147.274C147.273 144.876 148.536 142.529 149.853 140.076C149.051 139.958 148.389 139.862 147.49 139.728C150.346 135.696 152.005 131.187 153.725 126.435C155.519 131.133 157.083 135.683 160.022 139.725C159.123 139.853 158.439 139.949 157.62 140.067C158.934 142.5 160.194 144.828 161.509 147.262C160.859 147.425 160.277 147.572 159.504 147.767C160.891 150.021 162.241 152.215 163.629 154.472C162.871 154.683 162.199 154.869 161.323 155.112C163.079 157.616 164.767 160.017 166.615 162.652H155.558V171.349H151.957V162.713H140.826C142.69 160.055 144.379 157.648 146.16 155.112V155.121Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.485 177.064C219.881 176.892 219.427 176.764 218.931 176.623C219.865 175.104 220.767 173.63 221.71 172.098C221.23 171.977 220.831 171.878 220.367 171.763C221.237 170.141 222.09 168.555 222.983 166.896C222.439 166.816 221.991 166.749 221.384 166.662C223.315 163.935 224.434 160.887 225.598 157.677C226.81 160.852 227.869 163.928 229.854 166.662C229.247 166.749 228.783 166.816 228.23 166.893C229.119 168.536 229.969 170.113 230.858 171.756C230.42 171.868 230.027 171.967 229.503 172.098C230.439 173.624 231.354 175.104 232.291 176.633C231.779 176.777 231.325 176.901 230.73 177.064C231.917 178.756 233.058 180.38 234.309 182.161H226.832V188.042H224.399V182.203H216.875C218.135 180.406 219.276 178.778 220.482 177.064H220.485Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.253 219.432C249.648 219.259 249.194 219.131 248.699 218.991C249.632 217.472 250.534 215.998 251.477 214.466C250.998 214.345 250.598 214.245 250.134 214.13C251.004 212.509 251.858 210.923 252.75 209.263C252.206 209.184 251.759 209.116 251.151 209.03C253.083 206.302 254.202 203.255 255.366 200.045C256.578 203.22 257.636 206.296 259.622 209.03C259.014 209.116 258.551 209.184 257.997 209.26C258.886 210.904 259.737 212.48 260.626 214.124C260.188 214.236 259.795 214.335 259.27 214.466C260.207 215.991 261.122 217.472 262.058 219C261.547 219.144 261.093 219.269 260.498 219.432C261.684 221.124 262.826 222.748 264.076 224.529H256.6V230.41H254.167V224.571H246.643C247.902 222.774 249.044 221.146 250.25 219.432H250.253Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.213 160.478C132.193 160.19 131.432 159.972 130.597 159.736C132.167 157.178 133.689 154.696 135.275 152.113C134.466 151.908 133.798 151.742 133.015 151.543C134.482 148.816 135.918 146.139 137.421 143.348C136.507 143.214 135.752 143.102 134.729 142.951C137.981 138.36 139.867 133.227 141.827 127.817C143.871 133.163 145.649 138.347 148.997 142.948C147.973 143.095 147.193 143.204 146.259 143.338C147.756 146.107 149.192 148.761 150.688 151.531C149.949 151.716 149.284 151.886 148.408 152.106C149.988 154.674 151.526 157.171 153.106 159.742C152.242 159.982 151.478 160.193 150.48 160.471C152.479 163.32 154.401 166.058 156.505 169.057H143.915V178.96H139.816V169.127H127.141C129.264 166.102 131.186 163.362 133.213 160.471V160.478Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.305 163.592C201.285 163.304 200.524 163.087 199.689 162.85C201.259 160.292 202.781 157.811 204.367 155.227C203.558 155.022 202.89 154.856 202.107 154.658C203.574 151.93 205.01 149.254 206.513 146.462C205.598 146.328 204.844 146.216 203.82 146.066C207.072 141.474 208.959 136.342 210.919 130.931C212.963 136.278 214.74 141.461 218.088 146.063C217.065 146.21 216.285 146.318 215.351 146.453C216.848 149.222 218.283 151.876 219.78 154.645C219.041 154.831 218.376 155 217.5 155.221C219.08 157.788 220.618 160.286 222.197 162.857C221.334 163.097 220.57 163.308 219.572 163.586C221.571 166.435 223.492 169.172 225.596 172.171H213.007V182.075H208.908V172.242H196.232C198.356 169.217 200.277 166.476 202.305 163.586V163.592Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.301 228.434C233.281 228.146 232.52 227.929 231.685 227.692C233.255 225.134 234.777 222.653 236.363 220.069C235.554 219.864 234.886 219.698 234.103 219.5C235.57 216.772 237.006 214.096 238.509 211.304C237.594 211.17 236.84 211.058 235.817 210.908C239.069 206.316 240.955 201.184 242.915 195.773C244.959 201.12 246.737 206.303 250.084 210.904C249.061 211.052 248.281 211.16 247.347 211.295C248.844 214.064 250.28 216.718 251.776 219.487C251.037 219.672 250.372 219.842 249.496 220.063C251.076 222.63 252.614 225.128 254.193 227.699C253.33 227.938 252.566 228.149 251.568 228.428C253.567 231.277 255.488 234.014 257.593 237.013H245.003V246.916H240.904V237.084H228.229C230.352 234.059 232.274 231.318 234.301 228.428V228.434Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 2.13603,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.972 49.5993L105.979 3L4 66.2943L115.544 131.382",
    stroke: "white",
    strokeWidth: 3.84357,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.572 89.9055L346 148.266L242.844 199.652L237.236 202.648L180.375 169.469",
    stroke: "white",
    strokeWidth: 3.84357,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ce75465ac941ad1ee10bbbec7ddf24ec.svg";
export { ForwardRef as ReactComponent };